import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { ERemittaBiller } from '../models/remita.model';

@Injectable({
  providedIn: 'root',
})
export class PaymentService extends BaseService {
  protected override baseURL = `v1/payment/`;
  constructor() {
    super();
  }
  checkRRRIsPaid = (query: { rrr: string; billerType: ERemittaBiller }) =>
    this.get<{ code: '00'|string; message: string }>(`remita/status`, query);
}
